import Grades from "./components/grades";
import GradeDistribution from "./components/gradeDistribution";
import EarlyAlerts from "./components/earlyAlerts";
import StudentHelp from "../academicProfile/components/studentHelp";
import NextTerm from "../dashboard/components/nextTerm";
import CourseDetails from "./components/courseDetails";
import { IStudentGrades } from "../../../models/dashboard/studentDashboard";
import { connect } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { getSnapShots } from "../../../action/masters/snapShotActionCreator";
import { getStudentTermDetails } from "../../../action/student/studentTermDetailsActionCreators";

const StudentGrades = (props: IStudentGrades) => {
  const { getSnapShots, getAllTerms, terms } = props;

  useEffect(() => {
    getAllTerms();
  }, []);

  const [selectedTerm, setSelectedTerm] = useState(terms?.[0]?.id ?? null);

  useEffect(() => {
    if (terms?.length > 0) {
      setSelectedTerm(terms[0]?.id);
    }
  }, [terms]);

  useEffect(() => {
    getSnapShots();
  }, []);

  const handleTermChange = (term: number) => {
    setSelectedTerm(term);
  };

  return (
    <>
      <div className="grades-wrap">
        <div className="tabs mb-3">
          {terms?.map((Term) => (
            <button
              className={`${selectedTerm === Term?.id ? "active" : ""}`}
              onClick={() => handleTermChange(Term?.id)}
            >
              {Term?.name}
            </button>
          ))}
        </div>
        <div className="row">
          <div className="col-lg-4 mb-3">
            <Grades selectedTerm={selectedTerm} />
          </div>
          <div className="col-lg-4 mb-3">
            <GradeDistribution />
          </div>
          <div className="col-lg-4 mb-3">
              <NextTerm/>
          </div>
          <div className="col-lg-4">{<EarlyAlerts />}</div>
          <div className="col-lg-4">
            <CourseDetails selectedTerm={selectedTerm} />
          </div>
          <div className="col-lg-4">
            <StudentHelp />
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getSnapShots: () => getSnapShots(),
  getAllTerms: () => getStudentTermDetails(),
};

function mapStateToProps(state: any) {
  return {
    terms: state.studentTermDetail.studentTermDetail,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentGrades);
